import React, { useState, useEffect } from 'react';
import { Stack, Typography } from '@mui/material';
import { animate } from 'framer-motion';

const AnimatedCounter = ({
    countTo,
    textBefore = '',
    textAfter = '',
    ...props }) => {
    const [count, setCount] = useState(0);
    const [displayCount, setDisplayCount] = useState(0);

    useEffect(() => {
        animate(displayCount, count, {
            duration: 1,
            onUpdate: (latest) => setDisplayCount(latest),
        });
    }, [count, displayCount]);

    useEffect(() => {
        if (countTo) {
            setCount(countTo);
        }
    }, [countTo]);
    return <Stack
        direction="row"
        spacing={.6}
    >
        <Typography {...props}>
            {textBefore}
        </Typography>
        <Typography {...props}
            color="warning"
        >
            <b>{Math.round(displayCount).toLocaleString()}</b>
        </Typography>
        <Typography {...props}>
            {textAfter}
        </Typography>
    </Stack >
};

export default AnimatedCounter;